module.exports = __webpack_public_path__ + "media/images/projects/secteur_icon-0bcee5506f49e5964d985abaa50c7d1d.svg";